let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5XOhk")).then(() => parcelRequire('6zMq5'));